import React from 'react'
import { useAppSelector } from 'reduxTyped'

import * as flowSimulatorSelectors from 'common/builder/components/flowSimulator/selectors/flowSimulatorSelectors'

const IfFlowSimulatorHidden = ({
  builderId,
  children,
}: {
  builderId: string
  children?: React.ReactNode
}) => {
  const isOpen = useAppSelector((state) =>
    flowSimulatorSelectors.isFlowSimulatorOpen(state, builderId),
  )

  if (!isOpen) {
    return <>{children}</>
  }

  return null
}

export default IfFlowSimulatorHidden
